import { useMap } from "@vis.gl/react-google-maps";
import MapApiRepository from "../repositories/MapApiRepository";
import { useEffect, useState } from "react";
import { MapPolygon } from "./MapPolygon";
import { isArrayEmpty, isNullOrEmpty } from "../../../helpers/ObjectHelpers";
import MapService, { IMapService } from "../services/MapService";
import MapPropertiesService from "../services/MapPropertiesService";
import { useWarningNotification } from 'components/hooks/useAppStore';

interface MapPecFairwayAreasProps {
    pecId: number,
    pecLatitude?: number | null,
    pecLongitude?: number | null,
}

export const MapPecFairwayAreas = ({
    pecId,
    pecLatitude = 0,
    pecLongitude = 0
}: MapPecFairwayAreasProps) => {

    const map = useMap();   
    const mapService: IMapService = new MapService();
    const mapProperties = MapPropertiesService.properties;

    const [features, setFeatures] = useState<any[]>([]);
    const [hasInitialized, setHasInitialized] = useState(false);
    const addWarningNotification = useWarningNotification();

    useEffect(() => {
        
        if (!map || hasInitialized) return;
        
        const initialize = async () => {
            const response: any = await MapApiRepository.searchPecFairwayAreasAsync(pecId, {latitude: pecLatitude, longitude: pecLongitude });
            if (response.ok) {
                const bounds = new window.google.maps.LatLngBounds();
                const data = await response.json();

                if (isArrayEmpty(data)) {
                    if (pecLatitude && pecLatitude > 0 && pecLongitude && pecLongitude > 0) {
                        addWarningNotification('Ingen farledsomr&aring;der funnet i n&aelig;rheten av oppgitt posisjon.');

                        map!.setCenter({ lat: pecLatitude, lng: pecLongitude });
                    }
                } else {
                    const filteredData = data.filter((x: any) => !isNullOrEmpty(x.wkt));
                    for (const fairwayArea of filteredData) {
                        if (isNullOrEmpty(fairwayArea.wkt)) continue;
                        mapService.setFairwayAreaGeometryAndBounds(fairwayArea);
                        fairwayArea.properties = {
                            name: fairwayArea.fairwayAreaNameNor,
                            featureType: mapProperties.FairwayAreaFeatureType
                        };

                        const coordinates = mapService.getCoordinatesFromGeometry(fairwayArea.geometry);
                        mapService.extendBounds(bounds, coordinates);
                    }

                    setFeatures(filteredData);

                    map!.setCenter(bounds.getCenter());
                    map!.fitBounds(bounds);
                }
            }
        }

        initialize();
        setHasInitialized(true);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [map])

    return (
        features.map((feature: any, index: number) =>
            <MapPolygon
                ref={null}
                key={index}
                source={feature}

            />
        )
    )
}
